import React from "react"
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
} from "@chakra-ui/react"
import MenuItemRadio, { MenuItemRadioProps } from "@components/MenuItemRadio"

interface MenuItemRadioGroupProps {
  label: string
  items: Array<MenuItemRadioProps>
}

const MenuItemRadioGroup: React.FC<MenuItemRadioGroupProps> = ({
  label,
  items,
}) => {
  return (
    <Accordion allowToggle defaultIndex={0}>
      <AccordionItem>
        <AccordionButton
          display="flex"
          justifyContent="space-between"
          p="20px 0"
        >
          <Text
            fontFamily="Avenir"
            color="dark"
            fontSize="19px"
            fontStyle="normal"
            fontWeight="800"
            lineHeight="24px"
            letterSpacing="0em"
            textAlign="left"
          >
            {label}
          </Text>
          <AccordionIcon color="dark" />
        </AccordionButton>
        <AccordionPanel p={"0 0 22px"}>
          {items.map((item, i) => (
            <MenuItemRadio key={i} {...item} />
          ))}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default MenuItemRadioGroup
